/**
 * Trigger a browser download of a generated text file. The blob carries the
 * content's own encoding markers (e.g. a UTF-8 BOM), so no transcoding here;
 * the object URL is revoked after the click so the blob can be collected.
 */
export const downloadTextFile = (
	filename: string,
	content: string,
	mimeType = 'text/csv;charset=utf-8',
): void => {
	const url = URL.createObjectURL(new Blob([content], { type: mimeType }))
	const anchor = document.createElement('a')
	anchor.href = url
	anchor.download = filename
	document.body.appendChild(anchor)
	try {
		anchor.click()
	} finally {
		document.body.removeChild(anchor)
		window.setTimeout(() => URL.revokeObjectURL(url), 0)
	}
}
